/* eslint-disable react/prop-types */
import React from "react";
import { useNavigate } from "react-router-dom";

const headerList = [
  {
    name: "日期",
    key: "date",
  },
  {
    name: "支出類型",
    key: "typeName",
  },
  {
    name: "單號",
    key: "no",
  },
  {
    name: "支付對象",
    key: "payeeName",
  },
  {
    name: "總計金額",
    key: "totalAmount",
  },
];

function typeToChinese(type) {
  const typeMap = {
    procurement: "採購單",
    employeeInvoice: "請款單",
    otherExpenditure: "其他支出",
    procurementInvoice: "到貨單",
  };

  return typeMap[type] || type;
}

function getIdAndDisplayNo(item) {
  switch (item.type) {
    case "employeeInvoice":
      return {
        id: item.employeeInvoiceID,
        displayNo: `#${item.employeeInvoiceID}`,
      };
    case "otherExpenditure":
      return {
        id: item.otherExpenditureID,
        displayNo: `#${item.otherExpenditureID}`,
      };
    case "procurement":
      return {
        id: item.procurementID,
        displayNo: `#${item.procurementID}`,
      };
    case "procurementInvoice":
      return {
        id: item.procurementID,
        displayNo: `#${item.procurementID}-${item.invoiceID}`,
      };
    default:
      return {
        id: item.id,
        displayNo: `#${item.id}`,
      };
  }
}

const typeOrder = {
  procurementInvoice: 1,
  employeeInvoice: 2,
  otherExpenditure: 3,
  procurement: 4,
};

function compareDetail(a, b) {
  const orderA = typeOrder[a.type] ?? 99;
  const orderB = typeOrder[b.type] ?? 99;
  if (orderA !== orderB) return orderA - orderB;

  const dateA = a.date || "";
  const dateB = b.date || "";
  if (dateA !== dateB) return dateA < dateB ? -1 : 1;

  switch (a.type) {
    case "procurementInvoice": {
      const pidA = a.procurementID || "";
      const pidB = b.procurementID || "";
      if (pidA !== pidB) return pidA < pidB ? -1 : 1;
      const iidA = a.invoiceID || "";
      const iidB = b.invoiceID || "";
      if (iidA === iidB) return 0;
      return iidA < iidB ? -1 : 1;
    }
    case "employeeInvoice":
      return (a.employeeInvoiceID || 0) - (b.employeeInvoiceID || 0);
    case "otherExpenditure":
      return (a.otherExpenditureID || 0) - (b.otherExpenditureID || 0);
    case "procurement": {
      const pA = a.procurementID || "";
      const pB = b.procurementID || "";
      if (pA === pB) return 0;
      return pA < pB ? -1 : 1;
    }
    default:
      return 0;
  }
}

const StatisticDetailTableV2 = ({ detailList }) => {
  const navigate = useNavigate();

  const formatDetailList = [...detailList].sort(compareDetail).map((item) => {
    const { id, displayNo } = getIdAndDisplayNo(item);
    return {
      ...item,
      id,
      typeName: typeToChinese(item.type),
      no: displayNo,
      totalAmount: item.totalAmount?.toLocaleString(),
    };
  });

  const viewDetail = (type, id) => {
    if (type === "procurement") {
      navigate(`/procurement/detail/${id}`);
    } else if (type === "employeeInvoice") {
      navigate(`/employeeInvoice/detail/${id}`);
    } else if (type === "otherExpenditure") {
      navigate(`/account-payable/detail/otherExpenditure/${id}`);
    } else if (type === "procurementInvoice") {
      navigate(`/procurement/detail/${id}`);
    }
  };

  return (
    <div>
      <div className="overflow-x-auto mt-10 ">
        <table className="table">
          <thead className="text-center">
            <tr className=" text-[#91949D] font-medium text-xl pb-6 border-b border-[#91949D] border-solid">
              {headerList.map((header, index) => (
                <td key={index}>{header.name}</td>
              ))}
            </tr>
          </thead>
          <tbody className="text-center">
            {formatDetailList.map((detail) => {
              const rowKey = `${detail.type}-${detail.no}`;
              return (
                <tr
                  key={rowKey}
                  onClick={() => viewDetail(detail.type, detail.id)}
                  className="text-lg border-b border-[#91949D] border-solid hover:bg-[#C4E1FF] odd:bg-[#ECF5FF]"
                >
                  {headerList.map((header) => (
                    <td key={`${rowKey}-${header.key}`}>
                      {detail[header.key] || ""}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatisticDetailTableV2;
